import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor() { }

  public getFeedbackPostURL():string {
    return environment.feedbackPostURL;
  }

  public getCheckForUpdatesIntervalInMilliSeconds():number{
    return environment.updateInterval;
  }

  public hasServiceWorker():boolean{
    return environment.hasServiceWorker;
  }

  public getCsvFolderLocation():string{
    return environment.csvFolderLocation;
  }
}
